module.exports = __webpack_public_path__ + "assets/img/img3.025bc4f8.png";